import type React from 'react';
import classes from './vacations-page.module.scss';
import { STATUS_LABELS, formatDate } from './vacations-page.utils';
import { useVacationsPageController } from './useVacationsPageController';

export const VacationsPage: React.FC = () => {
  const {
    isManager,
    section,
    setSection,
    startDay,
    setStartDay,
    endDay,
    setEndDay,
    comments,
    setComments,
    isLoading,
    hasMore,
    isLoadingMore,
    onLoadMore,
    onCreateVacation,
    onDecideVacation,
    visible,
    tabs,
  } = useVacationsPageController();

  return (
    <div className={classes.vacationsPage} dir="rtl">
      <header className={classes.vacationsTitle}>
        <h1>חופשים</h1>
      </header>

      {!isManager && (
        <section className={classes.vacationCreatePanel}>
          <h2>חופשה חדשה</h2>
          <form className={classes.vacationForm} onSubmit={onCreateVacation}>
            <label>
              תאריך התחלה
              <input
                required
                type="date"
                value={startDay}
                onChange={(event) => setStartDay(event.target.value)}
              />
            </label>
            <label>
              תאריך סיום
              <input
                required
                type="date"
                value={endDay}
                onChange={(event) => setEndDay(event.target.value)}
              />
            </label>
            <label className="vacationCommentsField">
              הערות
              <textarea
                value={comments}
                maxLength={4000}
                onChange={(event) => setComments(event.target.value)}
              />
            </label>
            <button type="submit">שליחת בקשה</button>
          </form>
        </section>
      )}

      <section className={classes.vacationsPanel}>
        <div className={classes.vacationTabs} role="tablist">
          {tabs.map(([key, label]) => (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={section === key}
              className={section === key ? 'active' : ''}
              onClick={() => setSection(key)}
            >
              {label}
            </button>
          ))}
        </div>

        {isLoading ? (
          <p className={classes.vacationEmpty}>טוען...</p>
        ) : visible.length === 0 ? (
          <p className={classes.vacationEmpty}>אין בקשות להצגה</p>
        ) : (
          <div className={classes.vacationList}>
            {visible.map((vacation) => (
              <article className={classes.vacationItem} key={vacation.id}>
                <div className={classes.vacationItemHeader}>
                  <div>
                    {isManager && <strong>{vacation.employeeName}</strong>}
                    <span dir="ltr">
                      {formatDate(vacation.startDay)} - {formatDate(vacation.endDay)}
                    </span>
                  </div>
                  <span
                    className={`${classes.vacationStatus} ${vacation.status === 'pending' ? 'pending' : classes[vacation.status]}`}
                  >
                    {STATUS_LABELS[vacation.status]}
                  </span>
                </div>
                {vacation.comments && <p className={classes.vacationComment}>{vacation.comments}</p>}
                {isManager && vacation.status === 'pending' && (
                  <div className={classes.vacationDecisionActions}>
                    <button
                      type="button"
                      className={classes.approve}
                      onClick={() => void onDecideVacation(vacation.id, 'approved')}
                    >
                      אישור
                    </button>
                    <button
                      type="button"
                      className={classes.reject}
                      onClick={() => void onDecideVacation(vacation.id, 'rejected')}
                    >
                      דחייה
                    </button>
                  </div>
                )}
              </article>
            ))}
          </div>
        )}
        {hasMore && !isLoading && <button type="button" disabled={isLoadingMore} onClick={() => void onLoadMore()}>טעינת בקשות נוספות</button>}
      </section>
    </div>
  );
};
